var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.9879 5.79343L11.25 7.53133L7.96875 4.25008L9.70664 2.51219C9.79454 2.42434 9.91372 2.375 10.038 2.375C10.1623 2.375 10.2814 2.42434 10.3693 2.51219L12.9879 5.12898C13.0316 5.17254 13.0664 5.22431 13.0901 5.28132C13.1138 5.33834 13.126 5.39947 13.126 5.46121C13.126 5.52295 13.1138 5.58408 13.0901 5.6411C13.0664 5.69811 13.0316 5.74988 12.9879 5.79343Z",
    fill: "#4398CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3195 4.79913L10.701 2.18116C10.6139 2.09408 10.5106 2.025 10.3968 1.97788C10.2831 1.93075 10.1611 1.90649 10.038 1.90649C9.91486 1.90649 9.79293 1.93075 9.67918 1.97788C9.56542 2.025 9.46206 2.09408 9.375 2.18116L2.14981 9.40635C2.06238 9.49309 1.99306 9.59635 1.94588 9.71011C1.8987 9.82388 1.87461 9.94589 1.875 10.069V12.6876C1.875 12.9362 1.97378 13.1747 2.14959 13.3505C2.32541 13.5263 2.56386 13.6251 2.8125 13.6251H12.6563C12.7806 13.6251 12.8998 13.5757 12.9877 13.4878C13.0756 13.3999 13.125 13.2807 13.125 13.1564C13.125 13.032 13.0756 12.9128 12.9877 12.8249C12.8998 12.737 12.7806 12.6876 12.6563 12.6876H6.75704L13.3195 6.1251C13.4066 6.03804 13.4757 5.93469 13.5228 5.82093C13.5699 5.70717 13.5942 5.58525 13.5942 5.46211C13.5942 5.33898 13.5699 5.21706 13.5228 5.1033C13.4757 4.98954 13.4066 4.88618 13.3195 4.79913ZM2.8125 10.069L7.96875 4.9128L10.5873 7.53135L5.43106 12.6876H2.8125V10.069ZM11.25 6.86866L8.63204 4.2501L10.0383 2.84385L12.6563 5.46241L11.25 6.86866Z",
    fill: "#4398CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.374016eb6c16ac32cf44be8a06e42e9d.svg";
export { ForwardRef as ReactComponent };